// extracted by mini-css-extract-plugin
export default {"startMenuView":"StartMenu_startMenuView__x0dGk","background":"StartMenu_background__OO1ys","titleImage":"StartMenu_titleImage__6a3Yv","buttons":"StartMenu_buttons__uvvtH"};